<template>
  <!-- 预约会议 -->
  <div v-if="!showSubPage">
    <back-route-hdr v-bind="backRouteInfo"
                    @handle-back="handleRouteBack"></back-route-hdr>
    <van-form class="mar-top-10 reserve" style="padding-bottom: 80px">
      <van-cell-group>
        <template #title>
          <span>{{sysFormTitles.subject}}（{{formData.subject.length}}/30 字）</span>
          <span v-show="sysRequiredFields.subject" class="text-danger">*</span>
        </template>
        <van-field v-model="formData.subject" :placeholder="dftSubject" :disabled="!mid && isOrganizeMeetings"
                   rows="1" autosize type="textarea" maxlength="30"></van-field>
      </van-cell-group>

      <van-cell-group class="mar-top-10">
        <van-cell is-link @click="handleDatePicker('start')">
          <template #title>
            <span>开始时间</span><span class="text-danger"> *</span>
          </template>
          <template #right-icon>
            <span>{{timeCN.start}}</span>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
          </template>
        </van-cell>
        <van-cell is-link @click="handleDatePicker('end')">
          <template #title>
            <span>结束时间</span><span class="text-danger"> *</span>
          </template>
          <template #right-icon>
            <span>{{timeCN.end}}</span>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
          </template>
        </van-cell>
        <!--<van-cell is-link :value="dataSource.duration + ' 小时'"
                  @click="viewComPicker('duration')">
          <template #title>
            <span class="text-danger">*</span> <span>会议时长</span>
          </template>
        </van-cell>-->
      </van-cell-group>
      <p v-show="timeTips" class="mar-lft-10 text-sm pad-btm-5">* {{timeTips}}</p>

      <!-- 周期会议 -->
      <van-cell-group v-show="periodicDays && showPeriodic" class="mar-top-10">
        <van-cell :title="sysFormTitles.periodicReserve">
          <template #right-icon>
            <van-switch v-model="formData.isPeriodic" size="20px"></van-switch>
          </template>
        </van-cell>
        <div v-show="formData.isPeriodic">
          <van-cell title="重复频率" is-link value-class="text-primary"
                    :value="periodicTypesMap[`${dataSource.periodicInfo.periodicType}`]"
                    @click="viewComPicker('periodicType')"></van-cell>
          <div v-if="dataSource.periodicInfo.periodicType === 'custom'">
            <van-cell title="自选会议时间" is-link
                      :value="'共 '+(dataSource.periodicInfo.selection.length+1)+' 场会议'"
                      @click="handleSubPage(subComponentMap.periodicSelection)"></van-cell>
          </div>
          <van-cell v-else title="结束重复" is-link @click="handleDatePicker('periodic', true)">
            <template #right-icon>
              <span v-if="periodicInfoCN"
                    class="text-primary">于{{periodicInfoCN.untilDate}} {{periodicInfoCN.periodicTimes}}</span>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </template>
          </van-cell>
        </div>
      </van-cell-group>

      <van-cell-group v-show="!onlyReserveTlc" class="mar-top-10 mt-detail">
        <van-cell :title="`选择${sysFormTitles.meetingRoom}`" is-link
                  @click="handleSubPage(subComponentMap.room)"></van-cell>
        <div class="pad-hor pad-ver-5 flex-wrap-between" v-show="dataSource.chosenRoom.roomNum">
          <div class="pad-btm-5 flex flex-start flex-align-center">
            <span class="text-md">{{dataSource.chosenRoom.roomNum}}</span>
            <info-tip v-show="dataSource.chosenRoom.deviceExceptionTip"
                      class="van-cell__right-icon text-danger"
                      :message="dataSource.chosenRoom.deviceExceptionTip"></info-tip>
          </div>
          <div v-show="roomPics.length" @click="showRoomPics=true">
            <i class="iconfont icon-image van-cell__right-icon text-hv"></i>
          </div>
        </div>
        <van-cell v-show='conflictInfo.meetingRooms.length' is-link class="bord-top"
                  :title="`与${sysFormTitles.meetingRoom}的其它会议安排有冲突`"
                  title-class="text-danger" @click="handleShowConflicts(conflictTypes.meetingRooms)"></van-cell>
      </van-cell-group>
      <p class="mar-lft-10 text-sm pad-btm-0"
         v-show="dataSource.chosenRoom.remark">* {{dataSource.chosenRoom.remark}}</p>
      <!--<p class="mar-lft-10 text-danger text-sm text-hv pad-btm-0"
         v-show="showReChangeNotice && !isInMeeting">* 您已修改会议时间，请重新匹配{{sysFormTitles.meetingRoom}}</p>-->
      <p class="mar-lft-10 text-sm text-hv pad-btm-5"
         v-show="dataSource.chosenRoom.isServiceSupport">* {{sysFormTitles.meetingRoom}}支持提交服务需求</p>

      <!--<permit-container :permit-key="permitsMap.participantSeats">
        <van-cell-group v-show="dataSource.chosenRoom.seatPics && dataSource.chosenRoom.seatPics.length"
                        class="mar-top-10">
          <van-cell is-link @click="handleSubPage(subComponentMap.arrangeSeats)">
            <template #title>
              <span>{{sysFormTitles.participantSeats}}</span>
              <van-badge class="mar-lft-5" color="#2D69E0" v-show="roomSeats.length" :content="roomSeats.length">
              </van-badge>
            </template>
          </van-cell>
        </van-cell-group>
      </permit-container>-->

      <van-cell v-show="dataSource.chosenRoom.isRowSeatSupport" title="是否需要排座">
        <template #right-icon>
          <van-switch v-model="formData.isRowSeat" size="20px"></van-switch>
        </template>
      </van-cell>

      <van-cell-group v-show="reviewProcessOptions.length" class="mar-top-10">
        <van-cell is-link @click="viewComPicker('reviewProcess')"
                  :value="reviewProcessMap[formData.reviewProcessCode]">
          <template #title>
            <span>{{sysFormTitles.reviewProcess}}</span>
            <span class="text-danger"> *</span>
          </template>
        </van-cell>
      </van-cell-group>

      <!-- 视频会议 -->
      <van-cell-group v-show="sysTlcMFs.length" class="mar-top-10">
        <van-cell>
          <template #title>
            <span>{{sysFormTitles.teleconference}} - {{hasTeleconference ? '是' : '否'}}</span>
            <tlc-logo v-show="mDocManufacturer || sysTlcMFs.length===1"
                      :tlc-manufacturer="tlcManufacturer" :margin-class="'mar-lft-10'"></tlc-logo>
          </template>
          <template #right-icon>
            <van-switch v-show="!onlyReserveTlc" v-model="hasTeleconference" size="20px"
                        :disabled="lockTlc"></van-switch>
          </template>
        </van-cell>

        <div v-if="isOrganizeMeetings && cMDoc.teleconferenceInfo"
             class="pad-hor pad-btm-10">
          <p class="mar-ver-5">会议号码：{{formData.teleconferenceInfo.conferenceNum}}</p>
          <p class="mar-ver-5">会议密码：{{formData.teleconferenceInfo.password}}</p>
          <!--<p v-show="formData.teleconferenceInfo.conferenceCtrlPwd" class="mar-ver-5">
            主持人密码：{{formData.teleconferenceInfo.conferenceCtrlPwd}}</p>
          <p class="text-ellipsis mar-ver-5">会议链接：{{formData.teleconferenceInfo.joinUrl}}</p>-->
        </div>
        <div v-else-if="hasTeleconference && formData.teleconferenceType">
          <van-field name="radio" v-if="sysTlcMFs.length>1 && !lockTlc">
            <template #input>
              <van-radio-group v-model="teleconferenceMF" direction="horizontal" icon-size="16px">
                <van-radio v-for="mf in sysTlcMFs" :key="mf" :name="mf">
                  <tlc-logo :tlc-manufacturer="mf" :margin-class="'mar-rgt-10'"></tlc-logo>
                </van-radio>
                <!--<van-radio v-show="dataSource.chosenRoom.roomNum" name="related">手填会议号</van-radio>-->
              </van-radio-group>
            </template>
          </van-field>
          <!--<van-field name="radio" v-else-if="dataSource.chosenRoom.roomNum && !lockTlc">
            <template #input>
              <van-radio-group v-model="formData.teleconferenceType" direction="horizontal">
                <van-radio name="created">新建会议</van-radio>
                <van-radio name="related">手填会议号</van-radio>
              </van-radio-group>
            </template>
          </van-field>-->

          <van-field v-show="!tlcOnlyRelated && waitingRoomKey" label="安全设置" left-icon=" iconfont icon-zhuyi-circle"
                     :error-message="tlcSecurityNotice">
            <template #input>
              <van-checkbox v-model="setTlcPwd" shape="square" icon-size="14px">会议密码</van-checkbox>
              <van-checkbox v-show="waitingRoomKey" v-model="formData.teleconferenceInfo.settings[waitingRoomKey]"
                            class="mar-lft-20"
                            shape="square" icon-size="14px">等待室
              </van-checkbox>
            </template>
          </van-field>
          <van-field v-show="setTlcPwd" v-model="formData.teleconferenceInfo.password"
                     label="会议密码" left-icon=" iconfont icon-shuru" placeholder="请输入密码" maxlength="10"></van-field>
          <van-field v-show="hasCtrlPwd" v-model="formData.teleconferenceInfo.conferenceCtrlPwd"
                     label="主持人密码" left-icon=" iconfont icon-shuru" placeholder="请输入主持人密码" maxlength="10"></van-field>

          <collapse-cell v-show="tlcSettingInfo.length && !tlcOnlyRelated"
                         :title="'高级设置'" icon=" iconfont icon-shezhi">
            <van-field v-for="ele in tlcSettingInfo" :key="ele.value"
                       @click="formData.teleconferenceInfo.settings[ele.value]=!formData.teleconferenceInfo.settings[ele.value]">
              <template #input>
                <van-checkbox v-model="formData.teleconferenceInfo.settings[ele.value]"
                              shape="square" icon-size="14px">{{ele.label}}
                </van-checkbox>
              </template>
            </van-field>
          </collapse-cell>

          <van-field v-if="tlcOnlyRelated"
                     v-model="formData.teleconferenceInfo.conferenceNum"
                     left-icon=" iconfont icon-shuru" label="会议号码" maxlength="15"
                     type="digit" input-align="right" placeholder="请输入会议号码"></van-field>
          <van-field v-if="tlcOnlyRelated"
                     v-model="formData.teleconferenceInfo.password"
                     left-icon=" iconfont icon-shuru" label="会议密码" maxlength="10"
                     input-align="right" placeholder="请输入会议密码"></van-field>
        </div>
      </van-cell-group>
      <!--<permit-container :permit-key="permitsMap.clickJoinMeeting">
        <p class="mar-lft-10 text-sm text-hv pad-btm-5"
           v-show="sysTlcMFs.length">* {{sysFormTitles.meetingRoom}}含视频会议主机时可【一键入会】</p>
      </permit-container>-->

      <!-- 直播会议 -->
      <van-cell-group v-show="hasTeleconference && curLvcManufacturer" class="mar-top-10">
        <van-cell>
          <template #title>
            <span>{{sysFormTitles.liveConference}} - {{formData.enableLiveConference ? '是' : '否'}}</span>
          </template>
          <template #right-icon>
            <van-switch v-model="formData.enableLiveConference" size="20px" :disabled="lockTlc"></van-switch>
          </template>
        </van-cell>
        <div v-show="formData.enableLiveConference">
          <!--<van-field v-model="formData.liveConferenceInfo.desc" placeholder="选填，请输入简介(100字以内)"
                     label="直播简介" rows="1" autosize type="textarea" maxlength="100"></van-field>-->

          <van-field label="是否对外">
            <template #input>
              <van-radio-group v-model="formData.liveConferenceInfo.external" icon-size="16px"
                               :disabled="lockTlc" direction="horizontal">
                <van-radio :name="true">是</van-radio>
                <van-radio :name="false">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-show="formData.liveConferenceInfo.external"
                     v-model="formData.liveConferenceInfo.password"
                     label="直播密码" placeholder="请输入4位数字密码" maxlength="10"></van-field>

          <van-cell v-show="sysLvcPrivileges.length" is-link
                    @click="viewComSelect('privilege', formData.liveConferenceInfo.privilege)">
            <template #title>
              <span>观看范围</span>
            </template>
            <template #right-icon>
              <span v-show="lvcPrivilegesWds" class="text-normal">{{lvcPrivilegesWds}}</span>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </template>
          </van-cell>
          <p v-show="sysLvcPrivileges.length"
             class="mar-lft-10 text-sm text-danger pad-btm-10">* 未选择观看范围，则全员可观看</p>
        </div>
      </van-cell-group>

      <!--分会场-->
      <van-cell-group v-show="hasTeleconference && showPermits.branchVenues" class="mar-top-10">
        <van-cell :title="'选择'+sysFormTitles.branchVenues" is-link
                  :value="dataSource.branchVenues.length? (dataSource.branchVenues.length+' 项'): ''"
                  @click="handleSubPage(subComponentMap.branchVenues)"></van-cell>
        <div class="pad-hor pad-ver-5 flex-wrap-between" v-show="dataSource.branchVenues.length">
          <div class="pad-btm-5 flex flex-start flex-align-center">
            <span class="text-md">{{dataSource.branchVenues.map(e => e.name).join('、')}}</span>
          </div>
        </div>
        <van-cell v-show='conflictInfo.exclusiveRooms.length' is-link class="bord-top"
                  :title="`与${sysFormTitles.branchVenues}的其它会议安排有冲突`"
                  title-class="text-danger" @click="handleShowConflicts(conflictTypes.exclusiveRooms)"></van-cell>
      </van-cell-group>

      <!-- 参会人相关 -->
      <van-cell-group class="mar-top-10">
        <van-field v-show="showPermits.numberOfPeople" v-model="formData.numberOfPeople"
                   maxlength="5" type="digit" input-align="right" right-icon="friends-o">
          <template #label>
            <span>{{sysFormTitles.numberOfPeople}}</span>
            <span v-show="sysRequiredFields.numberOfPeople" class="text-danger"> *</span>
          </template>
        </van-field>
        <van-cell :value="participantList" is-link
                  @click="handleSubPage(subComponentMap.participant)">
          <template #title>
            <span>{{sysFormTitles.insideParticipant}}</span>
            <span v-show="sysRequiredFields.insideParticipant" class="text-danger"> *</span>
          </template>
        </van-cell>
        <van-cell v-show="conflictInfo.participants.length" is-link
                  :title="`与${sysFormTitles.insideParticipant}的其它会议安排有冲突`"
                  title-class="text-danger" @click="handleShowConflicts(conflictTypes.participants)"></van-cell>
      </van-cell-group>

      <van-cell-group class="mar-top-10">
        <van-cell v-if="showPermits.initiator" is-link
                  :value="dataSource.initiator.name ? dataSource.initiator.name : ''"
                  @click="handleSubPage(subComponentMap.initiator)">
          <template #title>
            <span>{{sysFormTitles.initiator}}</span>
            <span v-show="sysRequiredFields.initiator" class="text-danger"> *</span>
          </template>
        </van-cell>
        <van-cell v-if="showPermits.sponsor" is-link
                  :value="dataSource.sponsor.name ? dataSource.sponsor.name : ''"
                  @click="handleSubPage(subComponentMap.sponsor)">
          <template #title>
            <span>{{sysFormTitles.sponsor}}</span>
            <span v-show="sysRequiredFields.sponsor" class="text-danger"> *</span>
          </template>
        </van-cell>
        <van-cell v-if="showPermits.copyTo" :title="sysFormTitles.copyTo"
                  :value="copyToUserList" is-link
                  @click="handleSubPage(subComponentMap.copyTo)"></van-cell>
      </van-cell-group>

      <!-- 客户级别设置 -->
      <permit-container v-show="dataSource.chosenRoom.roomNum" :permit-key="permitsMap.customerAttendance">
        <van-cell-group class="mar-top-10">
          <van-cell :title="sysFormTitles.customerAttendance">
            <template #right-icon>
              <van-switch v-model="hasCustomer" size="20px"></van-switch>
            </template>
          </van-cell>
          <van-cell v-show="hasCustomer" title="参会客户级别" is-link
                    :value="customerGradesMap[formData.customerGrade]"
                    @click="viewComPicker('customerGrade')"></van-cell>
        </van-cell-group>
        <p v-show="customerGradesMap[serviceGrade]" class="mar-lft-10 text-sm text-hv pad-btm-5">*
          {{customerGradesMap[serviceGrade]}} 以上客户参会可提交服务需求</p>
      </permit-container>

      <!-- 服务需求 -->
      <permit-container v-show="dftDemandOptions.length" :permit-key="permitsMap.serviceRequire">
        <van-cell-group class="mar-top-10">
          <van-cell :title="sysFormTitles.serviceRequire">
            <template #right-icon>
              <van-switch v-model="hasService" size="20px" :disabled="isInMeeting"></van-switch>
            </template>
          </van-cell>
          <div v-show="hasService">
            <van-field label="具体需求" left-icon=" iconfont icon-jilu" :disabled="isInMeeting"
                       v-model="formData.service.specificContent" placeholder="请填写服务具体需求"
                       rows="1" autosize type="textarea" maxlength="30"></van-field>
            <collapse-cell :title="'快捷需求'+(serviceSumPrice ? `（ 共￥${serviceSumPrice.toFixed(2)} ）` : '')"
                           :icon="'aim'" :outer-show="showQkDms">
              <van-cell v-for="(item,idx) in serviceQkDemands" :key="idx"
                        v-show="!isInMeeting || item.amount">
                <template #title>
                  <span>{{item.name}}</span>
                  <span v-if="item.price">（￥{{item.price.toFixed(2)}}/{{item.unit || '份'}} )</span>
                </template>
                <template>
                  <span v-if="isInMeeting">{{item.amount}} {{item.unit || '份'}}</span>
                  <van-stepper v-else v-model="item.amount" min="0" integer
                               @change="servicePriceChangeCnt++"></van-stepper>
                </template>
              </van-cell>
            </collapse-cell>
          </div>
        </van-cell-group>
        <p v-show="serviceSetting.reserveTip"
           class="mar-lft-10 text-sm text-hv pad-btm-5">* {{serviceSetting.reserveTip}}</p>
      </permit-container>

      <van-cell-group class="mar-top-10">
        <!-- 扩展属性 -->
        <div v-for="ele in extensionFieldSettings" :key="ele.key" class="bord-btm">
          <div v-if="ele.setType === extSetTypes.normal">
            <!-- <van-field v-if="!ele.options || !ele.options.length"
                       v-model="extensionFields[ele.key]"
                       :placeholder="'请输入'+ele.label">
              <template #label>
                <span>{{ele.label}}</span>
                <span v-show="ele.isRequired" class="text-danger"> *</span>
              </template>
            </van-field> -->
            <template v-if="ele.options && ele.options.length">
              <van-cell v-if="ele.isMulti" is-link
                        @click="viewComSelect(ele.key, extensionFields[ele.key], true)">
                <template #title>
                  <span>{{ele.label}}</span>
                  <span v-show="ele.isRequired" class="text-danger"> *</span>
                </template>
                <template #right-icon>
                  <span class="text-normal">{{getExtFieldDisplayVal(ele)}}</span>
                  <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
                </template>
              </van-cell>
              <van-cell v-else is-link :value="extensionFields[ele.key]"
                        @click="viewComPicker(ele.key, true)">
                <template #title>
                  <span>{{ele.label}}</span>
                  <span v-show="ele.isRequired" class="text-danger"> *</span>
                </template>
              </van-cell>
            </template>
          </div>

          <van-cell v-if="ele.setType === extSetTypes.structure" is-link
                    :value="getExtFieldDisplayVal(ele)"
                    @click="handleSubPage(ele.key, true)">
            <template #title>
              <span>{{ele.label}}</span>
              <span v-show="ele.isRequired" class="text-danger"> *</span>
            </template>
          </van-cell>

          <van-field v-if="ele.setType === extSetTypes.textarea"
                     v-model="extensionFields[ele.key]"
                     :placeholder="'请输入'+ele.label+'(100字以内)'"
                     rows="1" autosize type="textarea" maxlength="100">
            <template #label>
              <span>{{ele.label}}</span>
              <span v-show="ele.isRequired" class="text-danger"> *</span>
            </template>
          </van-field>

          <van-field v-if="ele.setType === extSetTypes.inputNumber"
                     v-model="extensionFields[ele.key]"
                     :placeholder="'请输入'+ele.label" type="number">
            <template #label>
              <span>{{ele.label}}</span>
              <span v-show="ele.isRequired" class="text-danger"> *</span>
            </template>
          </van-field>

          <van-cell v-if="ele.setType === extSetTypes.tip" :title="ele.label"
                    :value="ele.tips" :is-link="Boolean(ele.link)" :url="ele.link"></van-cell>
        </div>
        <van-field v-model="formData.meetingRemarks" placeholder="请输入备注(100字以内)"
                   label="会议备注" rows="1" autosize type="textarea" maxlength="100"></van-field>
      </van-cell-group>

      <van-cell-group class="mar-top-10">
        <van-cell title="会议提醒">
          <template #right-icon>
            <van-switch v-model="formData.enableNotice" size="20px"></van-switch>
          </template>
        </van-cell>
        <div v-show="formData.enableNotice">
          <van-cell title="会议开始提醒" is-link
                    :value="preNoticeChoiceMap[formData.preNoticeTime]"
                    @click="viewComPicker('preNotice')"></van-cell>
          <van-cell title="会议结束提醒" is-link
                    :value="endNoticeChoiceMap[formData.endNoticeTime]"
                    @click="viewComPicker('endNotice')"></van-cell>
        </div>
      </van-cell-group>
      <p class="mar-lft-10 text-sm pad-btm-5">* 含会议邀请、会议变更提醒等会议通知</p>

      <div class="mar-hor fixed-btn">
        <van-button block @click="submitReserve">提交{{this.mid ? "修改" : "预约"}}</van-button>
      </div>
    </van-form>

    <!-- 页面 & 隐藏组件 分割线 -->

    <!-- 选择完整时间 -->
    <van-popup v-model="showDatePicker" position="bottom">
      <div style="position: relative">
        <van-datetime-picker type="datetime" :key="datePickerFor"
                             :title="datePickerData.title"
                             :value="datePickerData.value"
                             :min-date="datePickerData.minDate"
                             :max-date="datePickerData.maxDate"
                             :filter="dateFilter" :formatter="dateFormatter"
                             @change="changeStartDate"
                             @confirm="confirmDate" @cancel="showDatePicker = false">
        </van-datetime-picker>
        <div class="week-value">{{weekValue}}</div>
      </div>
    </van-popup>
    <!-- 仅选择日期 -->
    <van-calendar v-model="showShtDatePicker" color="#2D69E0"
                  :title="datePickerData.title"
                  :default-date="datePickerData.value || null"
                  :min-date="datePickerData.minDate"
                  :max-date="datePickerData.maxDate"
                  @confirm="confirmDate"></van-calendar>

    <van-popup v-model="showCommonPicker" position="bottom">
      <van-picker show-toolbar :title="comPickerData.title"
                  :columns="comPickerData.columns" :default-index="comPickerData.value"
                  @cancel="showCommonPicker = false" @confirm="comPickerConfirm"></van-picker>
    </van-popup>
    <van-popup v-model="showCommonSelect" position="bottom">
      <div class="area-container">
        <div class="van-picker">
          <div class="van-picker__toolbar">
            <button type="button" class="van-picker__cancel" @click="showCommonSelect = false">取消</button>
            <div class="van-ellipsis van-picker__title">{{comSelectData.title}}</div>
            <button type="button" class="van-picker__confirm" @click="comSelectConfirm">确认</button>
          </div>
        </div>
        <div class="area-tab-container mar-btm mar-lft-20">
          <van-checkbox-group v-model="comSelectedData">
            <van-cell v-for="ele in comSelectData.columns" :key="ele.value"
                      class="bord-btm" clickable>
              <template #title>
                <van-checkbox shape="square" icon-size="14px"
                              :name="ele.value">{{ele.text}}
                </van-checkbox>
              </template>
            </van-cell>
          </van-checkbox-group>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showConflictInfo" round closeable position="bottom" class="static-lg-pop">
      <div class="flex flex-column hgt-100-percent">
        <div class="text-hv pad-all text-lg btm-shadow text-center bord-box">
          <span>{{conflictTitle}}时间冲突提示</span>
        </div>
        <div v-if="showConflictType" class="pad-all bord-box auto-overflow">
          <div v-for="(ele, idx) in conflictInfo[showConflictType]" :key="idx"
               class="mar-btm bg-grad pad-all-10 bord-radius-5">
            <div>
              <span class="text-bold text-hv">{{ele.dateLabel}}</span>
              <van-tag type="danger" plain class="mar-lft-10 bord-radius-5 pad-hor-5">冲突</van-tag>
            </div>
            <div class="mar-top-5 mar-left-negative">
              <i :class="'iconfont ' + titleIcons.meetingTime" class="text-md"></i>
              <span class="mar-lft-5">{{ele.timeLabel}}</span>
            </div>
            <div class="mar-top-5 mar-left-negative">
              <i :class="'iconfont ' + titleIcons.subject" class="text-md"></i>
              <span class="mar-lft-5">{{ele.subject}}</span>
            </div>
            <div class="mar-top-5 mar-left-negative">
              <i :class="'iconfont ' + titleIcons.meetingRoom" class="text-md"></i>
              <span class="mar-lft-5">{{ele.roomLabel}}</span>
            </div>
            <div v-show="ele.userLabel" class="mar-top-5 mar-left-negative">
              <i class="iconfont icon-zhuyi-circle text-md"></i>
              <span class="mar-lft-5">{{ele.userLabel}}</span>
            </div>
            <div v-show="ele.reserveInterval" class="mar-top-5 mar-left-negative">
              <i class="iconfont icon-zhuyi-circle text-md"></i>
              <span class="mar-lft-5">会前会后预留间隔时间 {{ele.reserveInterval}} 分钟</span>
            </div>
          </div>

          <div v-show="!conflictInfo[showConflictType].length">
            <empty-notice :image="'meeting'" :desc="'暂无内容~'"></empty-notice>
          </div>
        </div>
      </div>
    </van-popup>

    <van-image-preview v-model="showRoomPics" :images="roomPics"></van-image-preview>
  </div>
  <div v-else-if="subComponent">
    <component v-bind:is="subComponent" v-bind="subComponentProps"
               @change-time="receiveTimeInfo"
               @change-info="receiveSubPageInfo"></component>
  </div>
</template>

<script>
  import {getStorage, setStorage, StorageKey} from "../../../../tools/storage";
  import {
    frontConfirm,
    checkShowPermit,
    customizedBackHdr,
    getExtensionFieldVal,
    savePagePosition,
    frontMultiConfirm
  } from "../../../../tools/utils";
  import {commonConfig, momentFormat, formTitleCfg, commonIcons} from "../../../../config/common";
  import {messageHdl, msgCode} from "../../../../tools/messageHdlr";
  import {meeting} from "../../../../server";
  import routerMeta from "../../router/routerMeta";
  import ParticipantsDetail from './subPages/ParticipantsDetail.vue'
  import ChooseUsers from './subPages/ChooseUsers.vue'
  import ChooseRoom from './subPages/ChooseRoom.vue'
  import InputVisitor from './subPages/InputVisitor.vue'
  import ArrangeSeats from './subPages/ArrangeSeats.vue'
  import PeriodicSelection from './subPages/PeriodicSelection.vue'
  import ChooseBranchVenues from './subPages/ChooseBranchVenues.vue'
  import TlcLogo from "../../components/TlcLogo"
  import CollapseCell from "../../components/CollapseCell"
  import InfoTip from "../../components/InfoTip"
  import meetingTimeMixin from '@/mixins/meetingTime'
  import sysParamsMixin from '@/mixins/sysParams'
  import reserveConflictsMixin from '@/mixins/reserveConflicts'
  import periodicInfoMixin from '@/mixins/periodicInfo'
  import conferenceMixin from '@/mixins/conference'
  import commonExecuteMixin from "@/mixins/commonExecute";

  const tlcTypes = {
    created: "created",
    related: "related",
  };
  const outPKeyMap = {
    ...formTitleCfg.outsideParticipant,
    headerColor: ""
  };

  const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

  export default {
    mixins: [
      sysParamsMixin,
      meetingTimeMixin,
      reserveConflictsMixin,
      periodicInfoMixin,
      conferenceMixin,
      commonExecuteMixin,
    ],
    components: {
      CollapseCell,
      InfoTip,
      TlcLogo
    },
    data() {
      return {
        username: getStorage(StorageKey.username),
        mid: "",
        rid: "",
        newMtBasedOnStore: false,  // 基于其它页面附带的信息创建会议（会议室时间、复制会议）
        cMDoc: null,
        formData: {  // 提交时需要的参数
          subject: "",
          startTime: "",
          endTime: "",
          numberOfPeople: "",
          meetingRooms: [],  // {id}
          insideParticipant: [],  // id
          deviceRequire: [],  // 仅作为填充参数
          outsideParticipant: [],
          copyToUsers: [],  // id
          teleconferenceType: "",  // created || related || ""
          teleconferenceInfo: {
            conferenceNum: null,
            password: "",
            conferenceCtrlPwd: "",
            // desc: "",
            settings: {},
          },
          enableLiveConference: false,
          liveConferenceInfo: {
            password: "",
            desc: "",
            privilege: [],  // 直播范围
            manufacturer: "",
            external: false,  //是否对外
          },
          service: {
            // quickDemands: [],
            specificContent: "",
          },
          sponsorUid: "",  // userId
          initiatorUid: "",  // userId
          enableNotice: true,
          preNoticeTime: 30,
          endNoticeTime: 15,
          customerGrade: 0,
          reviewProcessCode: "",

          isPeriodic: false,
          periodicInfo: {
            periodicType: commonConfig.periodicTypes.weekly.value,
            untilDate: 0,
            selection: [],
          },
          isRowSeat: false,

          extensionFieldJSON: "",  // JSON string
          meetingRemarks: ""
        },
        curHour: (new Date()).getHours(),
        dataSource: {
          startTime: "",  // Date()
          endTime: "",  // Date()
          duration: 60,  // 分钟
          chosenRoom: {roomId: "", roomNum: ""},
          insideParticipant: [],  // {userId, name, departments}
          outsideParticipant: [],  // {name, tel, email, ...}
          sponsor: {},  // {userId, name}
          initiator: {},  // {userId, name}
          copyToUsers: [],  // {userId, name, ...}
          branchVenues: [],  // 分会场
          periodicInfo: {
            periodicType: commonConfig.periodicTypes.weekly.value,
            untilDate: "",  // Date()
            selection: [],  // 周期会议自选的时间
          },
        },
        seatsArrangements: {}, // 排座

        extensionFields: {},
        extSetTypes: commonConfig.extFields.setTypes,

        subComponentMap: {
          room: "room",
          participant: "participant",
          innerUser: "innerUser",
          visitor: "visitor",
          arrangeSeats: "arrangeSeats",
          sponsor: "sponsor",
          initiator: "initiator",
          copyTo: "copyTo",
          periodicSelection: "periodicSelection",
          branchVenues: "branchVenues",
        },
        showSubPage: false,
        subPageFor: "",
        subPageFromDetail: false,
        // showReChangeNotice: false,
        hashKey: 1,

        // 视频会议相关
        hasTeleconference: false,
        setTlcPwd: true,
        teleconferenceMF: "",

        hasService: false,
        showQkDms: true,
        tmpQkDms: [],  // 服务快捷需求
        hasCustomer: false,
        servicePriceChangeCnt: 0,

        showDatePicker: false,
        showShtDatePicker: false,
        datePickerFor: "",
        showCommonPicker: false,
        pickerFor: "",
        showCommonSelect: false,
        comSelectedData: [],
        selectFor: "",
        forExtField: false,
        showRoomPics: false,
        weekValue: weeks[new Date().getDay()],
        titleIcons: commonIcons.titles,
      }
    },
    computed: {
      backRouteInfo() {
        return {
          backMode: commonConfig.backModes.func,
          curHash: this.hashKey + ""
        }
      },
      dataProxy() {
        return this.formData
      },
      timeCN() {
        return {
          start: this.dataSource.startTime && moment(this.dataSource.startTime).format(momentFormat.dateFormatDetailCN),
          end: this.dataSource.endTime && moment(this.dataSource.endTime).format(momentFormat.dateFormatDetailCN),
        }
      },
      participantList() {
        const {insideParticipant} = this.dataSource;
        const [firstEle] = insideParticipant;
        const len = insideParticipant.length + this.dataSource.outsideParticipant.length;
        return firstEle && (firstEle.name + (len > 1 ? ` 等${len}人` : "")) || "点击选择"
      },
      copyToUserList() {
        const copyToUsers = this.dataSource.copyToUsers || [];
        return copyToUsers[0] && (copyToUsers[0].name + (copyToUsers.length > 1 ? ` 等${copyToUsers.length}人` : "")) || "点击选择"
      },
      // 监听直播范围字的选择显示
      lvcPrivilegesWds() {
        const privilege = this.formData.liveConferenceInfo.privilege || [];
        if (!privilege.length) return "";
        return this.sysLvcPrivileges.filter(item => {
          return privilege.includes(item.id)
        }).map(e => e.name).join("、")
      },
      customerGradesMap() {
        const map = {};
        const {customerGrades} = this.$store.state.sysConfig;
        (customerGrades || []).forEach(ele => map[ele.value] = ele.label);
        return map
      },
      reviewProcessCols() {
        return this.reviewProcessOptions.map(e => ({...e, text: e.label}))
      },
      reviewProcessMap() {
        const map = {};
        this.reviewProcessOptions.forEach(ele => map[ele.value] = ele.label);
        return map
      },
      serviceGrade() {
        const grades = this.dftDemandOptions.map(e => e.grades || []).flat(1).sort((a, b) => a - b);
        // console.log(grades);
        return grades[0]
      },
      serviceQkDemands: {
        get: function () {
          const qkDemands = [...(this.tmpQkDms || [])];
          // console.log(qkDemands);
          return this.dftDemandOptions.map(dm => {
            let opt = {...dm, amount: 0};
            const qkDm = qkDemands.find(e => e.type === dm.name);
            if (qkDm) {
              opt = {...opt, ...qkDm};
            }
            return opt
          })
        },
        set: function (arr) {
          this.tmpQkDms = arr.length && arr.filter(e => e.amount) || []
        },
      },
      serviceSumPrice() {
        const cnt = this.servicePriceChangeCnt;  // 触发器，无计算作用
        return this.serviceQkDemands.reduce((sum, ele) => {
          return sum + (ele.amount && ele.price ? ele.amount * ele.price : 0)
        }, 0)
      },

      subComponent() {
        if (this.forExtField) return ChooseUsers;
        switch (this.subPageFor) {
          case this.subComponentMap.room:
            return ChooseRoom;
          case this.subComponentMap.copyTo:
          case this.subComponentMap.innerUser:
            return ChooseUsers;
          case this.subComponentMap.participant:
            return ParticipantsDetail;
          case this.subComponentMap.visitor:
            return InputVisitor;
          case this.subComponentMap.arrangeSeats:
            return ArrangeSeats;
          case this.subComponentMap.sponsor:
          case this.subComponentMap.initiator:
            return ChooseUsers;
          case this.subComponentMap.periodicSelection:
            return PeriodicSelection;
          case this.subComponentMap.branchVenues:
            return ChooseBranchVenues;
          default:
            return null
        }
      },
      subComponentProps() {
        if (this.forExtField) {
          const doc = this.extensionFieldSettings.find(e => e.key === this.subPageFor);
          if (doc) {
            if (doc.isMulti) {
              return {
                curData: this.extensionFields[doc.key] || [],
              };
            } else {
              return {
                singleDoc: this.extensionFields[doc.key] || {},
                isSingle: true
              }
            }
          }
          return null
        }
        switch (this.subPageFor) {
          case this.subComponentMap.room:
            return {
              curDoc: this.dataSource.chosenRoom,
              startTime: this.dataSource.startTime.valueOf(),
              endTime: this.dataSource.endTime.valueOf(),
              numberOfPeople: this.participantNum,
              isPeriodic: this.formData.isPeriodic,
            };
          case this.subComponentMap.innerUser:
            return {
              curData: this.dataSource.insideParticipant,
            };
          case this.subComponentMap.participant:
            this.dataSource.outsideParticipant = this.queryOutUserInfo(this.dataSource.outsideParticipant)
            return this.dataSource;
          case this.subComponentMap.visitor:
            return {
              curData: this.queryOutUserInfo(this.dataSource.outsideParticipant),
            };
          case this.subComponentMap.arrangeSeats:
            return {
              ...this.dataSource,
              seatsArrangement: this.roomSeats
            };
          case this.subComponentMap.sponsor:
            return {
              singleDoc: this.dataSource.sponsor || {},
              isSingle: true
            };
          case this.subComponentMap.initiator:
            return {
              singleDoc: this.dataSource.initiator || {},
              isSingle: true
            };
          case this.subComponentMap.copyTo:
            return {
              curData: this.dataSource.copyToUsers,
            };
          case this.subComponentMap.periodicSelection:
            return {
              curData: this.dataSource.periodicInfo.selection,
              minDate: this.dataSource.endTime,
              maxDate: moment(this.dataSource.startTime).add(this.periodicDays, 'day').toDate(),
              mtTime: {
                startTime: this.dataSource.startTime && moment(this.dataSource.startTime).startOf('m').valueOf(),
                endTime: this.dataSource.endTime && moment(this.dataSource.endTime).startOf('m').valueOf(),
              }
            };
          case this.subComponentMap.branchVenues:
            return {
              curData: this.dataSource.branchVenues,
            };
          default:
            return null
        }
      },

      datePickerData() {
        switch (this.datePickerFor) {
          case 'start':
            return {
              title: "开始时间",
              minDate: this.minDate,
              maxDate: this.maxDate,
              value: this.dataSource.startTime,
            };
          case 'end':
            return {
              title: "结束时间",
              minDate: this.minEndDate,
              maxDate: this.maxEndDate,
              value: this.dataSource.endTime,
            };
          case 'periodic':
            return {
              title: "周期会议结束于",
              minDate: moment(this.dataSource.startTime).toDate(),
              maxDate: moment(this.dataSource.startTime).add(this.periodicDays, 'day').toDate(),
              value: this.dataSource.periodicInfo.untilDate,
            };
          default:
            return {}
        }
      },
      comPickerData() {
        if (this.forExtField) {
          const doc = this.extensionFieldSettings.find(e => e.key === this.pickerFor);
          if (doc) {
            return {
              title: doc.label,
              columns: (doc.options || []).map(v => ({text: v, value: v})),
              value: (doc.options || []).findIndex(v => v === this.extensionFields[doc.key]),
            }
          }
          return {}
        }
        switch (this.pickerFor) {
          // case "duration":
          //   return {
          //     title: "会议时长 - 小时",
          //     columns: this.durationCols,
          //     value: this.durationCols.findIndex(e => e === this.dataSource.duration),
          //   };
          case "preNotice":
            return {
              title: "会议开始提醒",
              columns: this.preNoticeChoiceCols,
              value: this.preNoticeChoiceCols.findIndex(e => e.value === this.formData.preNoticeTime),
            };
          case "endNotice":
            return {
              title: "会议结束提醒",
              columns: this.endNoticeChoiceCols,
              value: this.endNoticeChoiceCols.findIndex(e => e.value === this.formData.endNoticeTime),
            };
          case "customerGrade":
            return {
              title: "参会客户级别",
              columns: this.customerGradeCols,
              value: this.customerGradeCols.findIndex(e => e.value === this.formData.customerGrade),
            };
          case "periodicType":
            return {
              title: "周期会议重复频率",
              columns: this.periodicTypeCols,
              value: this.periodicTypeCols.findIndex(e => e.value === this.dataSource.periodicInfo.periodicType),
            };
          case "reviewProcess":
            return {
              title: this.sysFormTitles.reviewProcess,
              columns: this.reviewProcessCols,
              value: this.reviewProcessCols.findIndex(e => e.value === this.formData.reviewProcessCode),
            };
          default:
            return {}
        }
      },
      comSelectData() {
        if (this.forExtField) {
          const doc = this.extensionFieldSettings.find(e => e.key === this.selectFor);
          if (doc) {
            return {
              title: doc.label,
              columns: (doc.options || []).map(v => ({text: v, value: v})),
            }
          }
        }
        switch (this.selectFor) {
          case "privilege":
            return {
              title: '直播观看范围',
              columns: this.sysLvcPrivileges.map(v => ({text: v.name, value: v.id})),
            };
          default:
        }
        return {}
      },
      roomSeats() {
        const roomId = this.dataSource.chosenRoom.roomId;
        return this.seatsArrangements[roomId] || []
      },
      // 相关人显示权限
      showPermits() {
        const permissionList = this.$store.state.permissionList || [];
        return {
          outsideParticipant: checkShowPermit(permissionList, this.permitsMap.outsideParticipant),
          sponsor: checkShowPermit(permissionList, this.permitsMap.sponsor),
          initiator: checkShowPermit(permissionList, this.permitsMap.initiator),
          numberOfPeople: checkShowPermit(permissionList, this.permitsMap.numberOfPeople),
          copyTo: checkShowPermit(permissionList, this.permitsMap.copyTo),
          branchVenues: checkShowPermit(permissionList, this.permitsMap.branchVenues),
        }
      },

      mgrResourceUrl() {
        return this.$store.state.sysView.mgrSrcUrl || ""
      },
      roomPics() {
        const room = this.dataSource.chosenRoom;
        // console.log(room)
        return (room && room.pictures || []).map(e => this.mgrResourceUrl + e.url)
      },
    },
    watch: {
      "dataSource.chosenRoom.roomId": function (val) {
        // console.log('change room:', val);
        if (val || this.isOrganizeMeetings) return;

        if (this.tlcOnlyRelated) {
          this.formData.teleconferenceType = "";
          this.hasTeleconference = false;
        }
      },
      "formData.teleconferenceType": function (newVal, oldVal) {
        this.changeTlcInfoByType(newVal, oldVal)
      },
      hasService: function (val) {
        if (!val) {
          this.showQkDms = true;
          this.formData.service = {specificContent: ""};
          this.serviceQkDemands = [];
        }
      },
      hasCustomer: function (val) {
        if (!val) {
          this.formData.customerGrade = 0
        }
      },
      "sysNoticeInfo": function (val) {
        if (!this.mid) {
          const enableNotice = val.enableNotice;
          this.formData.enableNotice = enableNotice;
          if (enableNotice === this.formData.enableNotice) {
            enableNotice && this.initNoticeTime()
          } else {
            this.formData.enableNotice = enableNotice;
          }
        }
      },
      "formData.enableNotice": function (val) {
        if (val) {
          this.initNoticeTime()
        } else {
          this.formData.preNoticeTime = 0;
          this.formData.endNoticeTime = 0;
        }
      },
      showSubPage: function (val) {
        val && savePagePosition('reserve');
        this.$nextTick(function () {
          window.scroll(0, localStorage.getItem("reserve"));
        })
      }
    },
    mounted() {
      this.mid = this.$route.params.mid;
      this.rid = this.$route.params.rid;
      this.initForm();

      // 监听浏览器回退
      window.addEventListener('popstate', () => {
        setTimeout(() => {
          window.scrollTo(0, localStorage.getItem("reserve"))
        }, 0)
      }, false)
    },
    destroyed() {
      this.$store.commit('setReserveInfo', null);
      localStorage.removeItem('reserve')
    },
    methods: {
      queryOutUserInfo(outsideParticipant) {
        outsideParticipant.forEach(async (item) => {
          const filter = {
            mid: this.mid,
            key: 'tel,email',
            name: item.name,
            tel: item.tel
          }
          const {searchOutUserInfo: res} = await meeting.queryOutUserInfo(this, filter);
          if (res.code === 0) {
            const {data} = res;
            filter.key.split(',').forEach(k => {
              item[k] = data[k];
            })
          }
        });
        return outsideParticipant
      },
      initForm() {
        this.initNoticeTime();
        this.formData.enableNotice = this.sysNoticeInfo.enableNotice;
        if (this.onlyReserveTlc) {
          this.hasTeleconference = true
        }
        if (this.userId) {
          const doc = {
            userId: this.userId,
            ...getStorage(StorageKey.userProfile, true),
          };
          if (!this.sysRequiredFields.numberOfPeople) {
            this.formData.numberOfPeople = 1;
          }
          if (!this.sysRequiredFields.insideParticipant) {
            this.dataSource.insideParticipant.push({...doc});
          }
          if (!this.sysRequiredFields.sponsor) {
            this.dataSource.sponsor = {...doc};
          }
          if (!this.sysRequiredFields.initiator) {
            this.dataSource.initiator = {...doc};
          }
        }
        // 传值预约会议
        const reserveInfo = this.$store.state.reserveInfo;
        if (reserveInfo) {
          // console.log(reserveInfo)
          if (reserveInfo.teleconferenceInfo) {
            if (reserveInfo.ccFromMid) {
              this.teleconferenceMF = tlcTypes.related
            } else if (reserveInfo.teleconferenceInfo.manufacturer) {
              this.teleconferenceMF = reserveInfo.teleconferenceInfo.manufacturer
            }
          }
          if (reserveInfo.startTime) {
            switch (this.$route.name) {
              // 首页/我的日程 只传开始时间
              case routerMeta.meetingReserveFromHome.name:
              case routerMeta.meetingReserveFromSch.name:
                this.dataSource.startTime = reserveInfo.startTime;
                return;
              case routerMeta.meetingReserveFromRoom.name:
              case routerMeta.meetingReserveFromMtDetail.name:
                this.newMtBasedOnStore = !reserveInfo.ccFromMid;
                this.cMDoc = {
                  ...reserveInfo,
                  status: null
                };
                this.formatMData();
                return;
              default:
                break
            }
          } else if (reserveInfo.meetingRooms && reserveInfo.meetingRooms.length) {
            const [firstRoom = {}] = reserveInfo.meetingRooms;  // todo: 多会议室
            this.dataSource.chosenRoom = firstRoom;
          }
        }
        // 编辑会议
        if (this.mid) {
          UILoader.load();
          // 查询会议
          meeting.queryDetail(this, {
            queryFilter: {
              selfCursor: this.mid,
              notDesensitize: true
            }
          }).then(({searchMeeting: data = {}}) => {
            UILoader.unload();
            const [edge] = (data.meetingEdges || []);
            if (edge && edge.cursor === this.mid && edge.meeting) {
              this.cMDoc = edge.meeting;
              this.cMDoc.mid = edge.cursor;
              this.formatMData();
            } else {
              vtToast("会议不存在")
            }
          }).catch(err => {
            UILoader.unload();
            // console.log(err);
            vtToast(err.message)
          });
          return
        }
        this.dataSource.startTime = this.dftStartDate;
      },
      formatMData() {
        // console.log(this.cMDoc)
        const {startTime, endTime, meetingRooms, service} = this.cMDoc;
        this.formData.subject = this.cMDoc.subject;
        this.formData.meetingRemarks = this.cMDoc.meetingRemarks;
        this.formData.extensionFieldJSON = this.cMDoc.extensionFieldJSON;
        this.formData.reviewProcessCode = this.cMDoc.reviewProcessCode;

        if (this.mid) {
          this.formData.numberOfPeople = this.cMDoc.numberOfPeople;
          this.formData.enableNotice = this.cMDoc.enableNotice;
          this.formData.preNoticeTime = this.cMDoc.preNoticeTime;
          this.formData.endNoticeTime = this.cMDoc.endNoticeTime;
        }

        this.formData.teleconferenceType = this.cMDoc.teleconferenceType;
        if (this.cMDoc.teleconferenceType) {
          const tlcInfo = this.cMDoc.teleconferenceInfo || {};
          this.teleconferenceMF = tlcInfo.manufacturer || "";
          this.hasTeleconference = true
        }
        //判断是否开启直播
        if (this.cMDoc.enableLiveConference) {
          this.formData.enableLiveConference = this.cMDoc.enableLiveConference;
          const lvcInfo = this.cMDoc.liveConferenceInfo;

          this.formData.liveConferenceInfo = {
            password: lvcInfo.password || "",
            desc: lvcInfo.desc || "",
            manufacturer: lvcInfo.manufacturer,
            privilege: (lvcInfo.privilege || []).map(e => e.id),
            external: lvcInfo.external || false
          }
        }
        if (this.hasTeleconference) {
          this.dataSource.branchVenues = this.cMDoc.branchVenues || []
        }

        if (this.cMDoc.customerGrade) {
          this.hasCustomer = true;
          this.formData.customerGrade = this.cMDoc.customerGrade;
        }

        this.formData.isPeriodic = this.cMDoc.isPeriodic;
        if (this.cMDoc.isPeriodic) {
          const periodicInfo = this.cMDoc.periodicInfo || {};
          this.dataSource.periodicInfo.periodicType = periodicInfo.periodicType;
          this.dataSource.periodicInfo.untilDate = periodicInfo.untilDate && (new Date(periodicInfo.untilDate)) || "";
          this.dataSource.periodicInfo.selection = periodicInfo.selection || [];
        }

        if (this.cMDoc.insideParticipant) {
          this.dataSource.insideParticipant = this.cMDoc.insideParticipant;
        }
        if (this.cMDoc.sponsor) {
          this.dataSource.sponsor = this.cMDoc.sponsor;
        }
        if (this.cMDoc.initiator) {
          this.dataSource.initiator = this.cMDoc.initiator;
        }
        this.dataSource.copyToUsers = this.cMDoc.copyToUsers || [];
        // 清洗 outsideParticipant
        this.dataSource.outsideParticipant = (this.cMDoc.outsideParticipant || []).map(otP => {
          return window._.mapObject(outPKeyMap, (val, key) => otP[key] || "")
        });
        // console.log(this.dataSource.outsideParticipant);
        const [firstRoom = {}] = meetingRooms || [];  // todo: 多会议室
        this.dataSource.chosenRoom = firstRoom;
        firstRoom.roomId && (this.seatsArrangements = {
          ...this.seatsArrangements,
          [firstRoom.roomId]: [...(firstRoom.seatsArrangement || [])]
        });

        this.formData.isRowSeat = this.cMDoc.isRowSeat;

        let startDate = moment(startTime).toDate();
        // 复制会议时的开始时间处理
        if (this.newMtBasedOnStore && this.$route.params.cmid && (moment().diff(startDate, 'm') > 0)) {
          // 当天时间
          const minutes = moment(startDate).diff(moment(startDate).startOf('d'), 'm');
          const curTime = moment().startOf('d').add(minutes, 'minutes');
          if (moment().diff(curTime, 'm') > 0) {
            startDate = curTime.add(1, 'd').toDate();
          } else {
            startDate = curTime.toDate()
          }
        }
        this.dataSource.duration = moment(endTime).diff(moment(startTime), 'm');
        if (!this.mid && this.dataSource.duration <= 0) {
          this.dataSource.duration = 60
        }
        this.dataSource.startTime = startDate;
        this.dataSource.endTime = moment(startDate).add(this.dataSource.duration, 'm').toDate();

        const quickDemands = (service || {}).quickDemands || [];
        if (service && (service.specificContent || quickDemands.length)) {
          this.formData.service = {
            specificContent: service.specificContent,
            quickDemands: quickDemands.map(e => ({type: e.type, amount: e.amount}))
          };
          this.tmpQkDms = [...this.formData.service.quickDemands];
          this.hasService = true;
          this.showQkDms = true;
        }
        if (this.formData.extensionFieldJSON) {
          this.formatExtFields()
        }
      },
      formatExtFields() {
        const cData = this.formData.extensionFieldJSON && JSON.parse(this.formData.extensionFieldJSON) || {};
        const setData = {};
        this.extensionFieldSettings.forEach(ele => {
          setData[ele.key] = getExtensionFieldVal(ele, cData)
        });
        // console.log(setData);
        this.extensionFields = {
          ...this.extensionFields,
          ...setData
        }
      },
      getExtFieldDisplayVal(cfg) {
        const key = cfg.key;
        const destVal = this.extensionFields[key];
        // console.log(key, destVal)
        if (cfg.setType === this.extSetTypes.structure) {
          if (cfg.isMulti) {
            const [firstEle] = destVal || [];
            const len = (destVal || []).length;
            return firstEle && (firstEle.name + (len > 1 ? ` 等${len}人` : "")) || "点击选择"
          }
          return destVal && destVal.name || "点击选择"
        }
        if (cfg.isMulti && Array.isArray(destVal)) {
          return destVal.join('、') || "无"
        }
      },

      initNoticeTime() {
        this.formData.preNoticeTime = this.getNoticeTime('preNoticeChoiceMap', this.sysNoticeInfo.preNoticeTime, 30);
        this.formData.endNoticeTime = this.getNoticeTime('endNoticeChoiceMap', this.sysNoticeInfo.endNoticeTime, 15);
      },
      handleSubPage(pageFor, forExtField = false) {
        // console.log({pageFor});
        if (this.isInMeeting) {
          switch (pageFor) {
            case this.subComponentMap.room:
              vtToast(`会议进行中，无法修改${this.sysFormTitles.meetingRoom}！`);
              return;
            case this.subComponentMap.copyTo:
              vtToast(`会议进行中，无法修改${this.sysFormTitles.copyTo}！`);
              return;
            default:
          }
        }
        this.subPageFor = pageFor;
        this.forExtField = forExtField;
        this.showSubPage = true;
      },
      receiveSubPageInfo(data) {
        switch (this.subPageFor) {
          case this.subComponentMap.room:
            // this.showReChangeNotice = false;
            if (data) {
              this.dataSource.chosenRoom = data;
              return;
            }
            break;
          case this.subComponentMap.innerUser:
            if (data) {
              this.dataSource.insideParticipant = data;
            }
            this.subPageFor = this.subComponentMap.participant;
            return;
          // break;
          case this.subComponentMap.participant:
            if (data) {
              const {inner, outer} = data;
              if (inner) {
                this.dataSource.insideParticipant = inner;
              }
              if (outer) {
                this.dataSource.outsideParticipant = outer;
              }
              if (data.add) {
                this.subPageFromDetail = true;
                this.subPageFor = this.subComponentMap.innerUser;
                return;
              }
            }
            this.subPageFromDetail = false;
            break;
          case this.subComponentMap.visitor:
            if (data && data.users) {
              this.dataSource.outsideParticipant = data.users;
            }
            break;
          case this.subComponentMap.arrangeSeats:
            if (data) {
              const roomId = this.dataSource.chosenRoom.roomId;  // todo: 多会议室
              this.seatsArrangements = {
                ...this.seatsArrangements,
                [roomId]: [...data]
              };
            }
            break;
          case this.subComponentMap.sponsor:
          case this.subComponentMap.initiator:
            if (data) {
              const [doc = {}] = data;
              this.dataSource[this.subPageFor] = {...doc};
            }
            break;
          case this.subComponentMap.copyTo:
            if (data) {
              this.dataSource.copyToUsers = data;
            }
            break;
          case this.subComponentMap.periodicSelection:
            if (data) {
              this.dataSource.periodicInfo.selection = data;
            }
            break;
          case this.subComponentMap.branchVenues:
            if (data) {
              this.dataSource.branchVenues = data;
            }
            break;
          default:
            if (data && this.forExtField) {
              if (this.subComponentProps.isSingle) {
                const [doc = {}] = data;
                this.extensionFields[this.subPageFor] = {...doc};
              } else {
                this.extensionFields[this.subPageFor] = data;
              }
            }
            this.showSubPage = false;
            return
        }
        this.showSubPage = false
      },
      receiveTimeInfo(data) {
        // console.log(data);
        this.dataSource.startTime = new Date(data.startTime);
        this.dataSource.endTime = new Date(data.endTime);
      },
      handleDatePicker(type, forShtDatePicker) {
        if (type === 'start' && this.isInMeeting) {
          vtToast("会议进行中，无法修改开始时间！");
          return
        }
        if (!this.mid && this.isOrganizeMeetings) {
          vtToast("来源于抄送的会议，无法修改时间！");
          return
        }
        this.datePickerFor = type;
        if (forShtDatePicker) {
          this.showShtDatePicker = true;
        } else {
          this.showDatePicker = true;
        }
      },
      dateFilter(type, options) {
        if (type === 'minute') {
          return options.filter((option) => option % this.unitMinutes === 0)
        }
        return options;
      },
      dateFormatter(type, val) {
        switch (type) {
          case 'year':
            return `${val}年`;
          case 'month':
            return `${val}月`;
          case 'day':
            return `${val}日`;
          default:
            return val;
        }
      },
      changeStartDate(evt) {
        this.curHour = evt.getColumnValue(3);

        // 计算当前选择日期是周几
        const dataStr = evt.getValues().slice(0, 3).reduce((result, item) => {
          return result ? result + '-' + parseInt(item) : parseInt(item);
        }, '');
        this.weekValue = weeks[new Date(dataStr).getDay()];
      },
      confirmDate(date) {
        switch (this.datePickerFor) {
          case 'start':
            this.dataSource.startTime = date;
            break;
          case 'end':
            this.dataSource.endTime = date;
            this.dataSource.duration = moment(date).diff(moment(this.dataSource.startTime), 'm');
            break;
          case 'periodic':
            this.dataSource.periodicInfo.untilDate = date;
            break;
          default:
        }
        this.showDatePicker = false;
        this.showShtDatePicker = false;
        this.datePickerFor = "";
        // if (this.dataSource.chosenRoom.roomId) {
        //   this.showReChangeNotice = true
        // }
      },
      viewComPicker(k, forExtField = false) {
        if (!this.mid && k === 'duration' && this.isOrganizeMeetings) {
          vtToast("来源于抄送的会议，无法修改时间！");
          return
        }
        if (k === 'preNotice' && this.isInMeeting) {
          vtToast("会议已开始");
          return
        }
        this.pickerFor = k;
        this.forExtField = forExtField;
        this.showCommonPicker = true;
      },
      comPickerConfirm(data) {
        switch (this.pickerFor) {
          case "duration":
            this.dataSource.duration = data;
            // if (this.dataSource.chosenRoom.roomId) {
            //   this.showReChangeNotice = true
            // }
            break;
          case "preNotice":
            this.formData.preNoticeTime = data.value;
            break;
          case "endNotice":
            this.formData.endNoticeTime = data.value;
            break;
          case "customerGrade":
            // 客户级别会影响服务内容，暂存数据
            this.tmpQkDms = this.serviceQkDemands.length && this.serviceQkDemands.filter(e => e.amount) || [];
            this.formData.customerGrade = data.value;
            break;
          case "periodicType":
            this.dataSource.periodicInfo.periodicType = data.value;
            break;
          case "reviewProcess":
            this.formData.reviewProcessCode = data.value;
            break;
          default:
            if (this.forExtField) {
              this.extensionFields[this.pickerFor] = data.value
            }
            break;
        }
        this.forExtField = false;
        this.showCommonPicker = false;
        this.pickerFor = ""
      },
      viewComSelect(k, data, forExtField = false) {
        this.selectFor = k;
        this.comSelectedData = data;
        this.forExtField = forExtField;
        this.showCommonSelect = true;
      },
      comSelectConfirm() {
        if (!this.comSelectedData) return;
        switch (this.selectFor) {
          case "privilege":
            this.formData.liveConferenceInfo.privilege = [...this.comSelectedData];
            break;
          default:
            if (this.forExtField) {
              this.extensionFields[this.selectFor] = [...this.comSelectedData];
            }
        }
        this.showCommonSelect = false;
        this.forExtField = false;
        this.comSelectedData = [];
        this.selectFor = ""
      },

      submitReserve() {
        const validateErr = [
          this.checkMeetingTime(),
          this.checkFormFields(),
          this.checkMeetingRoom(),
          this.checkPeriodicInfo(),
          this.checkConflictInfo(),
          this.checkConference(),
        ].find(e => {
          return e && true || false
        });
        if (validateErr) {
          vtToast(validateErr);
          return;
        }

        if (this.dftDemandOptions.length) {
          // console.log(this.serviceQkDemands)
          if (!this.isInMeeting) {
            this.formData.service.quickDemands = this.serviceQkDemands.filter(e => e.amount).map(e => ({
              type: e.name,
              price: e.price,
              unit: e.unit,
              amount: e.amount,
            }))
          }
        } else {
          this.formData.service = {}
        }

        const {chosenRoom, insideParticipant: _insideParticipant} = this.dataSource;
        const destData = {
          ...this.formData,
          startTime: this.dataSource.startTime.valueOf(),
          endTime: this.dataSource.endTime.valueOf(),
          numberOfPeople: this.participantNum,
          meetingRooms: chosenRoom.roomId ? [{
            id: chosenRoom.roomId,
          }] : [],
          insideParticipant: _insideParticipant.map(e => e.userId),
          outsideParticipant: (this.dataSource.outsideParticipant || []).map(otP => {
            return window._.mapObject(outPKeyMap, (val, key) => otP[key])
          }),
          sponsorUid: this.dataSource.sponsor.userId,
          initiatorUid: this.dataSource.initiator.userId,
          copyToUsers: this.dataSource.copyToUsers.map(e => e.userId),
          ccFromMid: this.cMDoc && this.cMDoc.ccFromMid,
          customerGrade: this.hasCustomer ? this.formData.customerGrade : 0,
          liveConferenceInfo: {  // 提交只保留以下字段
            password: this.formData.liveConferenceInfo.password,
            desc: this.formData.liveConferenceInfo.desc,
            manufacturer: this.curLvcManufacturer,
            privilege: this.formData.liveConferenceInfo.privilege,  //直播范围
            external: this.formData.liveConferenceInfo.external
          },
          periodicInfo: this.dataSource.formattedPeriodicInfo,
          branchVenueIds: (this.dataSource.branchVenues || []).map(e => e.id),
          extensionFieldJSON: JSON.stringify(this.dataSource.formattedExtFields),
          reserveWay: this.cMDoc && this.cMDoc.reserveWay ? this.cMDoc.reserveWay : commonConfig.reserveWays.mobile.value,
        };

        const {errMsg, tips = []} = this.getSubmitTips(destData);
        if (errMsg) {
          vtToast(errMsg);
          return;
        }
        frontMultiConfirm({title: "提交预约", withCancel: true}, tips, () => {
          this.submitMDoc(destData);
        })
      },
      handleResp(res) {
        messageHdl({code: msgCode.SUCCESS});
        setTimeout(() => {
          // 更新重定向路径为详情页
          // if (customizedBackHdr(this.$route.path)) return;
          const redirectRecord = getStorage(StorageKey.redirectRecord);
          if (res.insertId && redirectRecord && redirectRecord === this.$route.path) {
            const {href: path} = this.$router.resolve({
              name: routerMeta.meetingDetailFromSch.name,
              params: {mid: res.insertId}
            }, this.$route);
            setStorage(StorageKey.redirectRecord, path);
            this.$router.push({path: path});
            return
          }

          const mtBackRoute = getStorage(StorageKey.mtBackRoute);
          // 从各种会议详情路径，再约一场/组织会议
          if (res.insertId && this.$route.params.cmid && mtBackRoute) {
            // 匹配详情页路径
            const routeName = [
              routerMeta.meetingDetailFromSch.name,
              routerMeta.meetingDetailFromHome.name,
              // routerMeta.meetingDetailFromRoom.name,
            ].find(name => {
              const {href} = this.$router.resolve({name: name, params: {mid: this.$route.params.cmid}}, this.$route);
              return href === mtBackRoute;
            });
            if (routeName) {
              const {href: path} = this.$router.resolve({name: routeName, params: {mid: res.insertId}}, this.$route);
              // 从第三方系统直接访问会议详情，替换重定向路径
              if (redirectRecord === mtBackRoute) {
                setStorage(StorageKey.redirectRecord, path);
              }
              this.$router.push({path: path});
              return
            }
          }
          // 从各种会议详情路径，编辑
          if (this.mid && mtBackRoute) {
            this.$router.push({path: mtBackRoute});
            return
          }
          // meetingReserveFromRoom
          if (this.rid) {
            this.$router.push({
              name: routerMeta.meetingDetailFromRoom.name,
              params: {mid: res.insertId, rid: this.rid},
            });
            return;
          }
          const routeInfo = {
            name: routerMeta.meetingDetail.name,
            params: {mid: res.insertId || this.mid}
          };
          switch (this.$route.name) {
            case routerMeta.meetingReserveFromHome.name:
              routeInfo.name = routerMeta.meetingDetailFromHome.name;
              break;
            case routerMeta.tlcReserve.name:
            case routerMeta.meetingReserveFromSch.name:
              routeInfo.name = routerMeta.meetingDetailFromSch.name;
              break;
            default:
          }
          this.$router.push(routeInfo);
        }, 50)
      },
      // 根据进入页面的路由进行处理
      handleRouteBack() {
        frontConfirm({
          title: "退出" + (this.mid ? "编辑" : "预约"),
          msg: "该操作会丢失您当前编辑的内容，是否确认？",
          withCancel: true
        }, (res) => {
          if (!res) {
            this.hashKey++;  // 更新history
            return
          }
          if (customizedBackHdr(this.$route.path)) return;
          // 处理路由跳转
          switch (this.$route.name) {
            case routerMeta.meetingReserveFromMtDetail.name:
            case routerMeta.meetingEdit.name:
            case routerMeta.periodicMeetingEdit.name:
              const mtBackRoute = getStorage(StorageKey.mtBackRoute);
              if (mtBackRoute) {
                this.$router.push({path: mtBackRoute});
              } else {
                this.$router.push({
                  name: routerMeta.meetingDetail.name,
                  params: {mid: this.$route.params.mid || this.$route.params.cmid}
                });
              }
              break;
            case routerMeta.meetingReserveFromRoom.name:
              this.$router.push({name: routerMeta.roomDetail.name, params: this.$route.params});
              break;
            case routerMeta.meetingReserve.name:
            default:
              if (this.$route.meta.backRt) {
                this.$router.push({name: this.$route.meta.backRt});
                return;
              }
              this.$router.push({name: routerMeta.meetingList.name});
          }
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  .input-inline {
    width: 50% !important;
    padding: 0 !important;
    margin-left: 20px;

    .van-field__control {
      color: #1989fa !important;
      font-weight: bold;
    }
  }

  .text-normal {
    margin-left: 10px;
  }

  .reserve {
    // .van-cell {
    //   font-size: 15px !important;
    // }

    .van-field__label {
      color: inherit !important;
    }

    .van-cell-group__title {
      padding-top: 10px;
      color: #323233 !important;
    }

    .van-switch--on .van-switch__node {
      z-index: inherit;
    }
  }

  .week-value {
    position: absolute;
    left: 57.5%;
    top: 166px;
    z-index: 100;
  }

  .van-popup--bottom.van-popup--round {
    border-radius: 16px 16px 0 0;
  }

  .mar-left-negative {
    margin-left: -1px;
  }
</style>
